import { render } from "./transaction.vue?vue&type=template&id=337d1e3e&scoped=true&ts=true"
import script from "./transaction.vue?vue&type=script&lang=ts"
export * from "./transaction.vue?vue&type=script&lang=ts"

import "./transaction.vue?vue&type=style&index=0&id=337d1e3e&scoped=true&lang=stylus"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-337d1e3e"]])

export default __exports__